// extracted by mini-css-extract-plugin
export default {"wrapper":"PoweredBy_wrapper__4beyj","fixedWrapper":"PoweredBy_fixedWrapper__YkzUn","content":"PoweredBy_content__s4G55"};